import isEmptyArray from '../../general/isEmpty/isEmptyArray';

import * as exElement from '../element';
import { data } from './utils';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): HTMLElement {
    // Create element (overlays)
    const elOverlays = exElement.create({
        merge: config,
        class: {
            new: 'overlays',
        },
        style: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            left: '0',
        },
    });

    // ------------------------------------------------------------------------

    // Settings
    settings(elOverlays, config);

    // Return
    return elOverlays;
}

function settings(element: HTMLElement, config: Record<string, any> = {}): void {
    // If using data
    if (!isEmptyArray(config.data)) {
        const listOverlay = data(element, config);
        element.appendChildren(listOverlay);
    }
}

// ----------------------------------------------------------------------------

export { create, settings };
